import React from 'react'
import WebsiteNavbar from 'components/Navbars/WebsiteNavbar'


const Home = () => {

    const items = [
    {
      label: "About",
      bgColor: "#212529",
      textColor: "#fff",
      links: [
        { label: "Our Team", ariaLabel: "Our Team" },
        { label: "Our Mission", ariaLabel: "Our Mission" }
      ]
    },
    {
      label: "Premium Programs", 
      bgColor: "#212529",
      textColor: "#fff",
      links: [
        { label: "The Ultimate Predental Program", ariaLabel: "The Ultimate Predental Program" },
        { label: "DAT Live Session", ariaLabel: "DAT Live Session" }
      ]
    },
    {
      label: "DAT",
      bgColor: "#212529", 
      textColor: "#fff",
      links: [
        { label: "Tutoring", ariaLabel: "Tutoring" },
        { label: "Counseling", ariaLabel: "Counseling" }
      ]
    },
    {
      label: "Free Resources",
      bgColor: "#212529", 
      textColor: "#fff",
      links: [
        { label: "Podcast", ariaLabel: "Podcast" },
        { label: "Free Dental E-Book", ariaLabel: "Free Dental E-Book" },
        { label: "Masterclass", ariaLabel: "Masterclass" }
      ]
    }
  ];

  return (
    <div className="h-100vh">
        <WebsiteNavbar
        
            logo={require("../../assets/img/brand/tpc-pre-dental-logo-white.png")}
            logoAlt="Company Logo"
            items={items}
            baseColor="#fff"
            menuColor="#000"
            buttonBgColor="#111"
            buttonTextColor="#fff"
            ease="power3.out"
        >

        </WebsiteNavbar>
        
    </div>
  )
}

export default Home